import { useState } from 'react';
import { MappedAEMProperties } from '../../../../types';
import Layout from '../../../common/Layout/Layout';
import { ContentBlock } from '../../../../lib/types/aemDataModels';
import styles from './Accordion.module.scss';
import AccordionItem from './AccordionItem';
import { CY_ACCORDION } from '../../../../lib/constants/cypress';

export type AccordionProps = {
  items: ContentBlock[];
  singleItemExpansion?: boolean;
} & MappedAEMProperties;

const Accordion = ({ singleItemExpansion, items }: AccordionProps) => {
  const [selection, setSelection] = useState<ContentBlock>();

  return (
    <div className={styles.container} data-cy={CY_ACCORDION}>
      <Layout>
        <div className={styles.borderTop}>
          <div className={styles.borderBottom}>
            {items.map(item => (
              <AccordionItem
                key={item.uniqueId}
                item={item}
                onOpen={setSelection}
                selection={selection}
                singleItemExpansion={singleItemExpansion}
              />
            ))}
          </div>
        </div>
      </Layout>
    </div>
  );
};

export default Accordion;
